module.exports = __webpack_public_path__ + "ico-bmi.png?55c9a61b25032004ec57403207b545aa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/ico-bmi.png
// module id = 942
// module chunks = 0